import deepFreeze from 'deep-freeze-strict';
function isFreezable(value) {
  return value !== null && typeof value === 'object';
}
function freezeStoreState(store) {
  const state = store.getState();
  if (isFreezable(state)) {
    deepFreeze(state);
  }
}
export function freezeState(store) {
  return next => action => {
    freezeStoreState(store);
    try {
      next(action);
    } finally {
      freezeStoreState(store);
    }
  };
}